import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { ArrowRight, Apple, Gift, Award } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { useState } from "react";

const HeroSection = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleDownload = () => {
    window.open("https://singingfiles.com/show.php?l=0&u=2392393&id=69074", "_blank");
  };

  return (
    <section className="min-h-screen pt-24 pb-16 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-background to-secondary/20 flex items-center">
      <div className="max-w-7xl mx-auto w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="text-center lg:text-left"
          >
            <div className="inline-flex items-center px-3 py-1 rounded-full bg-primary/10 text-primary mb-6">
              <Apple className="h-4 w-4 mr-2" />
              <span className="text-sm font-medium">Nur für iOS in Deutschland</span>
            </div>
            
            <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-foreground mb-6 leading-tight">
              Lade das erste Spiel in der{" "}
              <span className="bg-gradient-to-r from-primary to-primary/80 bg-clip-text text-transparent">
                Rewards App
              </span>{" "}
              herunter!
            </h1>
            
            <p className="text-xl text-muted-foreground max-w-2xl mx-auto lg:mx-0 mb-8">
              Entdecke aufregende Spiele und erhalte exklusive Belohnungen. Jetzt die App herunterladen und sofort mit dem Spielen beginnen!
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <Button 
                size="lg" 
                className="bg-primary hover:bg-primary/90 text-primary-foreground"
                onClick={handleDownload}
              >
                Jetzt herunterladen
                <ArrowRight className="ml-2 h-4 w-4" />
              </Button>
              
              <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
                <DialogTrigger asChild>
                  <Button size="lg" variant="outline" className="border-primary text-foreground">
                    Mehr erfahren
                  </Button>
                </DialogTrigger>
                <DialogContent className="sm:max-w-md">
                  <DialogHeader>
                    <DialogTitle>Über die Rewards App</DialogTitle>
                  </DialogHeader>
                  <div className="space-y-4 py-4">
                    <p>
                      Die Rewards App bietet dir die Möglichkeit, durch das Spielen von spannenden Spielen exklusive Belohnungen zu erhalten. 
                    </p>
                    <div className="flex items-center gap-3 bg-secondary/50 p-3 rounded-lg">
                      <Gift className="h-8 w-8 text-primary flex-shrink-0" />
                      <div>
                        <h3 className="font-medium">Sammle Belohnungen</h3>
                        <p className="text-sm text-muted-foreground">Für jedes gespielte Spiel erhältst du wertvolle Punkte</p>
                      </div>
                    </div>
                    <div className="flex items-center gap-3 bg-secondary/50 p-3 rounded-lg">
                      <Award className="h-8 w-8 text-primary flex-shrink-0" />
                      <div>
                        <h3 className="font-medium">Exklusive Vorteile</h3>
                        <p className="text-sm text-muted-foreground">Tausche deine Punkte gegen exklusive Prämien ein</p>
                      </div>
                    </div>
                    <Button 
                      className="w-full mt-4" 
                      onClick={() => {
                        setIsDialogOpen(false);
                        handleDownload();
                      }}
                    >
                      Jetzt herunterladen
                    </Button>
                  </div>
                </DialogContent>
              </Dialog>
            </div>
            
            <div className="flex items-center justify-center lg:justify-start mt-8 text-sm text-muted-foreground">
              <span className="flex items-center">
                <Apple className="h-4 w-4 mr-1" />
                Nur für iOS
              </span>
              <span className="mx-2">•</span>
              <span>Nur in Deutschland verfügbar</span>
            </div>
          </motion.div>
          
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="relative"
          >
            <div className="relative mx-auto max-w-[320px]">
              <div className="absolute inset-0 bg-gradient-to-r from-primary/20 to-primary/10 rounded-[40px] blur-xl transform -rotate-6 scale-105 animate-pulse-light"></div>
              <div className="relative bg-gradient-to-r from-background to-secondary/50 border-4 border-primary/20 rounded-[40px] p-4 shadow-2xl animate-float">
                <img 
                  src="https://images.unsplash.com/photo-1621976360623-004223992275?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1287&q=80" 
                  alt="Rewards App Screenshot" 
                  className="rounded-3xl shadow-lg"
                />
                <div className="absolute -bottom-4 -right-4 bg-primary text-white text-sm font-bold px-4 py-2 rounded-full shadow-lg">
                  Neu!
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;